package org.ksdfv.thelema.kxjs.data

import org.khronos.webgl.ArrayBufferView
import org.ksdfv.thelema.data.IDataArray

/** @author zeganstyl */
abstract class JsArrayBufferView<T>: IDataArray<T> {
    abstract val array: ArrayBufferView

    override val sourceObject: Any
        get() = array

    override var position: Int = 0

    override fun rewind() {}
}